import { useState, useEffect } from "react";
import fetchFilters from '../../../../services/fetchFilters';

export default function useFetchFilters() {
  const [areFiltersLoaded, setAreFiltersLoaded] = useState(false);
  const [isFilterLoadingInProgress, setIsFilterLoadingInProgress] = useState(false);
  const [filterLoadingError, setFilterLoadingError] = useState(null);
  const [countryList, setCountryList] = useState([]);
  const [partnerRoleList, setPartnerRoleList] = useState([]);
  const [partnerIntegratorLevelList, setPartnerIntegratorLevelList] = useState([]);
  const [partnerIntegratorSpecializationList, setPartnerIntegratorSpecializationList] = useState([]);
  const [partnerProviderLevelList, setPartnerProviderLevelList] = useState([]);
  const [partnerProviderCiscoPoweredServiceList, setPartnerProviderCiscoPoweredServiceList] = useState([]);
  const [partnerDeveloperLevelList, setPartnerDeveloperLevelList] = useState([]);
  const [partnerDeveloperSpecializationList, setPartnerDeveloperSpecializationList] = useState([]);
  const [partnerAdvisorLevelList, setPartnerAdvisorLevelList] = useState([]);
  const [partnerAdvisorSpecializationList, setPartnerAdvisorSpecializationList] = useState([]);


  useEffect(
    () => {
      async function loadFilters() {
        const filters = await fetchFilters();
        if(!filters.hasError) {
          setCountryList(countryList => filters.countryList);
          setPartnerRoleList(partnerRoleList => filters.partnerRoleList);
          setPartnerIntegratorLevelList(partnerIntegratorLevelList => filters.partnerIntegratorLevelList);
          setPartnerIntegratorSpecializationList( partnerIntegratorSpecializationList => filters.partnerIntegratorSpecializationList);
          setPartnerProviderLevelList( partnerProviderLevelList => filters.partnerProviderLevelList);
          setPartnerProviderCiscoPoweredServiceList(partnerProviderCiscoPoweredServiceList => filters.partnerProviderCiscoPoweredServiceList);
          setPartnerDeveloperLevelList(partnerDeveloperLevelList => filters.partnerDeveloperLevelList);
          setPartnerDeveloperSpecializationList( partnerDeveloperSpecializationList => filters.partnerDeveloperSpecializationList);
          setPartnerAdvisorLevelList( partnerAdvisorLevelList => filters.partnerAdvisorLevelList);
          setPartnerAdvisorSpecializationList( partnerAdvisorSpecializationList => filters.partnerAdvisorSpecializationList);
          setAreFiltersLoaded(previousValue => true);
        }
        else {
          setFilterLoadingError(filters.errorMessage);
          setPartnerRoleList(partnerRoleList => []);
          setPartnerIntegratorLevelList(partnerIntegratorLevelList => []);
          setPartnerIntegratorSpecializationList( partnerIntegratorSpecializationList => []);
          setPartnerProviderLevelList( partnerProviderLevelList => []);
          setPartnerProviderCiscoPoweredServiceList(partnerProviderCiscoPoweredServiceList => []);
          setPartnerDeveloperLevelList(partnerDeveloperLevelList => []);
          setPartnerDeveloperSpecializationList( partnerDeveloperSpecializationList => []);
          setPartnerAdvisorLevelList(partnerAdvisorLevelList => []);
          setPartnerAdvisorSpecializationList( partnerAdvisorSpecializationList => []);
          setAreFiltersLoaded(previousValue => true);
        }
        setIsFilterLoadingInProgress(false);
      }
      setIsFilterLoadingInProgress(true);
      loadFilters();
    },
    []
  );

  return {
    isFilterLoadingInProgress,
    filterLoadingError,
    countryList,
    partnerRoleList,
    partnerIntegratorLevelList,
    partnerIntegratorSpecializationList,
    partnerProviderLevelList,
    partnerProviderCiscoPoweredServiceList,
    partnerDeveloperLevelList,
    partnerDeveloperSpecializationList,
    partnerAdvisorLevelList,
    partnerAdvisorSpecializationList,
    areFiltersLoaded
  }
}
